import axios from 'axios';
import Cookies from 'universal-cookie';

const BASE_URL = process.env.REACT_APP_BASE_URL;

export default axios.create({
  baseURL: BASE_URL
});


export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { 
    'Content-Type': 'application/json',
  },
});

axiosPrivate.interceptors.request.use(
  (config) => {
    const cookies = new Cookies();
    const token = cookies.get('auth-token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);



/*
import axios from 'axios';
import createAuthRefreshInterceptor from 'axios-auth-refresh';


axios.defaults.baseURL = 'http://localhost:8000';

//Function that will be called to refresh authorization
const refreshAuthLogic = (failedRequest) => {

  axios.post('/api/token/refresh').then((tokenRefreshResponse) => {
    localStorage.setItem('token_refresh', tokenRefreshResponse.data.token);
    failedRequest.response.config.headers['Authorization'] = 'Bearer ' + tokenRefreshResponse.data.token;
    return Promise.resolve();
  });

  console.log('refresh kick!')

}

// Instantiate the interceptor
createAuthRefreshInterceptor(axios, refreshAuthLogic);

// Make a call. If it returns a 401 error, the refreshAuthLogic will be run,
// and the request retried with the new token
// axios.get('https://www.example.com/restricted/area').then(/!* ... *!/).catch(/!* ... *!/);
export default axios;
*/
